import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';

import { AppCard, AppCol, AppGroup } from 'components/appComponents';

import { useLazyGetRequestQuery, useLazyGetRequestStatusQuery } from 'bus/request';
import { RequestItem } from 'bus/request/types';

import { StatusChange } from './components';

type StatusProps = {
  readOnly: boolean;
  value: string | number | null;
  onChange: (request: RequestItem) => void;
};

const Status: FC<StatusProps> = ({ readOnly, value, onChange }) => {
  const [getRequestStatus, { data: requestStatusDataList }] = useLazyGetRequestStatusQuery();
  const [getRequest] = useLazyGetRequestQuery();
  let { id } = useParams<{ id: string }>();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    id && getRequestStatus({ id });
  }, [getRequestStatus, id]);

  const refresh = async () => {
    if (id) {
      const result = await getRequest({ id }).unwrap();
      getRequestStatus({ id });
      onChange(result);
    }
  };

  const statusName = requestStatusDataList?.find((i) => i.id === value)?.name || 'неизвестно';
  const statusColor = requestStatusDataList?.find((i) => i.id === value)?.color || '#CCC';

  return (
    <>
      <StatusChange
        requestStatusDataList={requestStatusDataList}
        id={id}
        status={value}
        refresh={refresh}
        visible={visible}
        onHiding={() => setVisible(false)}
      />
      {id && (
        <AppCard className="pa-2 mb-2">
          <AppGroup title="Статус">
            <AppCol col={12}>
              <div className="mb-2 mt-2">
                <Button
                  style={{
                    backgroundColor: statusColor,
                  }}
                  text={statusName}
                  width="100%"
                  onClick={() => (readOnly ? false : setVisible(true))}
                />
              </div>
            </AppCol>
          </AppGroup>
        </AppCard>
      )}
    </>
  );
};

export default Status;
